import { Icon } from "@amzn/awsui-components-react";
import * as React from "react";
import { useState } from "react";
import "../../styles/component/layout/PageBaseLayout.scss";

export const PageBaseLayout = (props: {
    mainContent: JSX.Element;
    rightContent: JSX.Element;
    expandable?: boolean;
    hideRightSection?: boolean;
}) => {
    const [rightSectionExpanded, setRightSectionExpanded] = useState<boolean>(true);

    const sectionDivider = props.expandable ? (
        <div className="section-divider" onClick={() => setRightSectionExpanded(!rightSectionExpanded)}>
            { rightSectionExpanded ? <Icon name="angle-right-double"/> : <Icon name="angle-left-double"/> }
            <div className="vertical-line"/>
        </div>
    ) : (
        <div className="section-divider">
            <div className="dividedText"></div>
        </div>
    );

    React.useEffect(() => {
        if (!props.expandable) return;
        if (props.hideRightSection) setRightSectionExpanded(false);
    }, []);

    const containerStyle: React.CSSProperties = {
        transition: "all 0.3s ease-in-out"
    };

    return (
        <div className="page-layout" style={containerStyle}>
            {!props.hideRightSection ? (<>
                {/* Main Section with toggle-able Sidebar */}
                <div className={rightSectionExpanded ? "page-layout-main open" : "page-layout-main has-divider closed"}>
                    {props.mainContent}
                </div>
                {sectionDivider}
                <div className={rightSectionExpanded ? "page-layout-right open" : "page-layout-right closed"}>
                    {props.rightContent}
                </div>
            </>) : (
                // Main Section with no Sidebar
                <div className={"page-layout-main closed"}>
                    {props.mainContent}
                </div>
            )}
        </div>
    );
};
